// LT-611 — standalone public /demo page (GTM §7).
//
// A direct-linkable home for the "Get called by our AI now" widget — the URL we
// can drop into ads, QR codes, and outreach. Public + unauthenticated. Lives
// under src/pages/LandingPage/ to share the marketing styling + lint allowlist.
import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { track } from '../../utils/analytics';
import { AnalyticsEvents } from '../../utils/analyticsEvents';
import DemoCallWidget from './DemoCallWidget';

const DemoStandalonePage: React.FC = () => {
  const [params] = useSearchParams();
  // ?embed=1 → chrome-less mode for embedding the widget in an <iframe> on the
  // marketing site (agentnoda.ai). Drops the page header + dark backdrop so the
  // widget card sits on the host page's own background (LT-611).
  const embed = params.get('embed') === '1';

  useEffect(() => {
    track(AnalyticsEvents.LANDING_DEMO_CLICK, { surface: embed ? 'embed' : 'standalone' });
  }, [embed]);

  if (embed) {
    return (
      <div className="flex justify-center p-2">
        <DemoCallWidget />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-950 bg-gradient-to-b from-slate-900 to-slate-950 px-4 py-12">
      <div className="mx-auto max-w-xl">
        <div className="mb-8 text-center text-white">
          <Link to="/" className="text-sm text-cyan-300 hover:text-cyan-200">
            ← Agent Noda
          </Link>
          <h1 className="mt-4 text-3xl font-bold sm:text-4xl">Talk to our AI agent</h1>
          <p className="mt-2 text-gray-300">
            Pick a scenario and we'll call you — on your phone or in your browser.
          </p>
        </div>
        <div className="flex justify-center">
          <DemoCallWidget />
        </div>
      </div>
    </div>
  );
};

export default DemoStandalonePage;
